















import { IDrag } from "@components/ui/interface";
import Vue from "vue";
import { Component } from "vue-property-decorator";

const message = [
  "vue.draggable",
  "draggable",
  "component",
  "for",
  "vue.js 2.0",
  "based",
  "on",
  "Sortablejs",
];

@Component
export default class PageOtherComponent extends Vue {
  constructor() {
    super();
  }

  list: Array<IDrag> = [];

  created() {
    this.list = message.map((name, index) => {
      return { name, Id: index + 1, SortIndex: index + 1 };
    });

    // setInterval(() => {
    //   console.log(
    //     "this.list = ",
    //     this.list.map((x) => x.Id)
    //   );
    // }, 3000);
  }

  mounted() {}
}
